import { AutoComplete, Divider, Form, Input, Select, Switch, InputNumber } from "antd";
import React, { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { useParams } from "react-router";
import { getFunctions } from "./commonFunctions";
import tabName from "../../../../../../assets/svg/tab_ico.svg";
import typeName from "../../../../../../assets/svg/type_ico.svg";
import style from "./props.module.sass";
import { updateFormProperties } from "../../../../../../stateManager/store/formCreation/action";
import { updateAssetProperties } from "../../../../../../stateManager/store/assets/action";
import ColorPicker from "../../../../../../helpers/commonUi/ColorPicker";
import { findIdSelector } from "../reduxSelector";
import { useDebouncedAction, assetSelector } from '../../../../../../helpers/commonFunction'
import TarsLayout from "./TarsLayout";
import I18AutoCompletion from "./I18NAutoComplete";
import CustomAutoComplete from "./customAutoComplete";

const { Option } = Select;

let myWindow = window as any;

const PropertiesPanel: React.FunctionComponent<any> = (props) => {
  const { json, canEdit } = props;
  const id = json && json.id;
  const name = json.name
  const params: any = useParams();
  const { formId } = params;

  const selectedAssetId = useSelector((state: any) => state.assets.selectedAssetId);
  const assets = useSelector((state: any) => state.assets.list);
  const assetEditMode = useSelector((state: any) => state.assets.assetEditMode);

  let currentState: any = useSelector((state: any) => {
    return id ? findIdSelector(state, formId, id.split("#"), true) : [];
  });
  currentState = assetEditMode ? assetSelector(assets[selectedAssetId], id.split("#")) : currentState;

  const [idValue, setIdValue] = useDebouncedAction(currentState && currentState.elementId)
  const [isVisible, setIsVisible] = useState<boolean>(true);
  const [persistBlock, setPersistBlock] = useState<boolean>(false);
  const [functionsdef, setFunctionsdef] = useState<any>();
  const [editorCtx, setEditorCtx] = useState<string>("");
  const [modalVisibile, setModalVisible] = useState<boolean>(false);
  const [bindText, setBindText] = useDebouncedAction(currentState && currentState.bind)
  const [bindErr, setBindErr] = useState<boolean>(false);
  const [restrictUseEffect, setRestrictUseEffect] = useState(true);
  const editorRef = useRef(null)
  const [currentLine,setCurrentLine] = useState(3)
  const [tarsModal,setTarsModal] = useState(false)
  const [
    stateAutoCompleteVariables,
    setStateAutoCompleteVariables,
  ]: any[] = useState([]);
  const [AutoCompleteResult, setAutoCompleteResult]: any[] = useState([]);
  const autoCompleteAndLocalVariables = useSelector((state: any) => {
    return {
      localVariables: state.formcreation[params.formId],
      autocompleteVariables: state.formcreation.autoCompleteVariables,
    };
  });

  const [originalConfig, setOriginalConfig] = useState<any>({});
  const [pluginConfig, setPluginConfig] = useDebouncedAction({});
  const [selectedValue, setSelectedValue] = useState<any>([])

  let { pluginName, type, widgetName, properties } = currentState || {};
  type = type === "Image" ? "ImageViewer" : type

  useEffect(() => {
    if(type === "Uploader" && properties?.fileType){
      setSelectedValue(properties?.fileType)
    }
  },[])

  const [labelValue, setLabelValue] = useDebouncedAction(type === "TabBar" ? name : properties && properties.label);
  const [visibilityValue, setVisibilityValue] = useDebouncedAction(properties && properties.visibility && properties.visibility.condition)
  const dispatch = useDispatch();
  const version = useSelector(
    (state: any) => state.apps.appVersion[params["appId"]]
  );

  const onChange = useCallback((data: any, key: string) => {
    if (canEdit) {
      const setData = _.setWith({}, key, data, Object);
      if (assetEditMode && selectedAssetId) {
        dispatch(
          updateAssetProperties({
            assetId: selectedAssetId,
            id,
            data: setData,
          })
        );
      } else {
        dispatch(
          updateFormProperties({
            formid: formId,
            id,
            data: setData,
          })
        );
      }
    }
  }, [dispatch, formId, id, canEdit, assetEditMode, selectedAssetId]);

  const shouldShowField = (field: any) => {
    if (!field.hasOwnProperty("condition")) return true;
    // eslint-disable-next-line
    return Boolean(eval(field.condition))
  }

  const renderPanel = () => {
    const keys = Object.keys(originalConfig)
    const key: any = keys.find((el: any) => originalConfig[el].type === "Custom")

    if (!key) return null;

    const Panel = originalConfig[key].panel;
    const props = {
      properties,
      canEdit,
      onChange
    }
    return <Panel {...props} />;
  }

  useEffect(() => {
    let identifier = pluginName || type;
    identifier = identifier === "Image" ? "ImageViewer" : type

    if (myWindow[identifier]) {
      const { type: pluginType, data: plugin } = myWindow[identifier];
      let receivedConfig: any;

      if (pluginType === "Package" && widgetName) {
        receivedConfig = plugin.widgets[widgetName].config;
      } else {
        receivedConfig = plugin.config;
      }
      const renderConfig = { ...receivedConfig };

      // only keep the fields that belong to the property section
      Object.keys(renderConfig).forEach((key) => {
        const field = renderConfig[key];
        if (!field.section.startsWith("properties")) {
          delete renderConfig[key];
        }
      });
      setOriginalConfig(renderConfig);

      const properties = (currentState && currentState.properties) || {};
      const updatedPluginConfig = Object.keys(renderConfig).reduce(
        (a: any, c: any) => {
          const propertyValue = _.get(properties, getPath(renderConfig[c].section, c))
          const field: any = _.setWith(
            {},
            renderConfig[c].section,
            { [c]: propertyValue || renderConfig[c].value || renderConfig[c].default },
            Object
          );
          return _.merge(a, field.properties);
        },
        {}
      );
      setVisibilityValue(
        (properties.visibility && properties.visibility.condition) || ""
      );
      if (properties.visibility && properties.visibility.checked === false) {
        setIsVisible(false);
      }
      if (properties && properties.persistBlock === true) {
        setPersistBlock(true);
      }
      setPluginConfig({ ...properties, ...updatedPluginConfig }, () => null);
    }
    // TODO: Fix later why adding 'currentState' to the deps array results in infinite loop
    // eslint-disable-next-line
  }, [pluginName, type, widgetName]);

  const handleSearch = (id: string) => (value: any) => {
    let result: any[];
    if (!value) {
      result = [];
    } else {
      result = stateAutoCompleteVariables.filter((variables: any) => {
        let formName =
          props.selectedFormData && props.selectedFormData[0].formName;
        return formName === variables.formName && id === variables.id
          ? false
          : variables.bind.toUpperCase().indexOf(value.toUpperCase()) > -1;
      });
    }
    setAutoCompleteResult(result);
    // AutoCompleteResult

    // this.setState({ result });
  };

  useEffect(() => {
    if (restrictUseEffect) {
      const bindForms = (
        fields: any[],
        tabDetails: any,
        name: string,
        data: any[]
      ) => {
        _.each(fields, (fieldValue) => {
          if (fieldValue.bind) {
            data.push({
              ...tabDetails,
              name,
              ...fieldValue,
            });
          } else if (fieldValue.fields) {
            data = bindForms(
              fieldValue.fields,
              tabDetails,
              name,
              data
            );
          }
        });

        return data;
      };

      let formName =
        props.selectedFormData &&
        !!props.selectedFormData.length &&
        props.selectedFormData[0].formName;

      let responseData: any[] = [];
      _.each(autoCompleteAndLocalVariables.localVariables, (sValue) => {
        responseData = bindForms(
          sValue.fields,
          { tabName: sValue.name, tabId: sValue.id, tabKey: sValue.tabKey },
          formName,
          responseData
        );
      });

      setStateAutoCompleteVariables([
        ...responseData,
        ...autoCompleteAndLocalVariables.autocompleteVariables,
      ]);
      setRestrictUseEffect(false);
    }
  }, [
    props.selectedFormData,
    autoCompleteAndLocalVariables.autocompleteVariables,
    autoCompleteAndLocalVariables.localVariables,
    restrictUseEffect,
  ]);

  const autoCompleteChildren = () => {
    return AutoCompleteResult.slice(0, 10).map((variable: any, key: number) => {
      let formName =
        props.selectedFormData && props.selectedFormData[0].formName;
      return (
        <AutoComplete.Option data-test-id={`${key}`} key={key} label={variable.bind}>
          <div
          // style={{ border: "solid 1px #dee5f4", backgroundColor: "#f8fbff", borderRadius: "4px" }}
          >
            <ul key={key} style={{ listStyleType: "none", padding: "0px 0px" }}>
              <li>
                <span
                  style={{
                    color: "#000000",
                    fontSize: "14px",
                    fontWeight: 700,
                    paddingTop: "11px",
                  }}
                >
                  {variable.bind}
                </span>
              </li>
              <li>
                <span style={{ color: "#666980", paddingTop: "5px" }}>
                  {variable.formName}
                  {formName === variable.formName && "(current)"}
                </span>
              </li>
              <li>
                <span
                  style={{
                    color: "#FF5797",
                    paddingTop: "7px",
                    paddingRight: "6px",
                  }}
                >
                  <img src={tabName} alt={"tabname"} />
                </span>
                <span style={{ color: "#FF5797" }}>{variable.tabName}</span>
              </li>
              <li>
                <span
                  style={{
                    color: "#95abd3",
                    paddingTop: "7px",
                    paddingRight: "6px",
                    paddingBottom: "13px",
                  }}
                >
                  <img src={typeName} alt={"typename"} />
                </span>
                <span style={{ color: "#4993FD" }}>{variable.type}</span>
              </li>{" "}
            </ul>
            <Divider style={{ margin: "13px 0px 0px 0px" }}></Divider>
          </div>
        </AutoComplete.Option>
      );
    });

  };

  const renderBindComponent = () => {
    return (
      <Form.Item label="Bind" className={"a8-form-item props"} hasFeedback>
        <AutoComplete
          data-test-id="property_bind"
          dropdownMenuStyle={{ height: "338px", maxHeight: "350px" }}
          style={{ width: "100%" }}
          disabled={!canEdit || (assetEditMode && !currentState.editBind)}
          onChange={(text: any) => {
            const regex = "^[$a-zA-Z_]+[{}_a-zA-Z0-9_]*$"
            const findPattern = text!== "" ? text.match(regex) : true
            if (text !== "." && (text === '' || isNaN(text)) && findPattern) {
              let modifiedText: string;
              const textSplit = text.split(".");
              handleSearch(currentState.id)(text);
              if (textSplit.length >= 3) {
                !bindErr && setBindErr(true);
                modifiedText = `${textSplit[0]}.${textSplit[1]}`.replace(/\s/g, "")
              } else {
                bindErr && setBindErr(false)
                modifiedText = text.replace(/\s/g, "")
              }
              setBindText(modifiedText, () => onChange(modifiedText, "bind"))
            }
          }}
          onFocus={() => {
            handleSearch(currentState.id)(currentState.bind);
          }}
          placeholder="Bind"
          className={style.borderRemove}
          value={bindText}
          onSelect={(_inputValue, option: any) => {
            const { label } = option.props;
            handleSearch(json.id)(label);
            onChange(label.replace(/\s/g, ""), "bind");
            const value = label.replace(/\s/g, "")
            setBindText(value, () => onChange(value, "bind"))
          }}
          optionLabelProp="label"
        >
          {autoCompleteChildren()}
        </AutoComplete>
        {bindErr && (
          <div className={style.bindError}>
            Bind value cannot be nested more than once
          </div>
        )}
      </Form.Item>
    );
  };


  const [labelBlur, setLabelBlur] = useState(true);
  const [placeBlur, setPlaceBlur] = useState(true);

  const openCodeEditorModal = async (ctx: string) => {
    try {
      let data = await getFunctions(params["appId"], version.versionId);
      setFunctionsdef(data);
    } catch (e) { }
    setModalVisible(true);
    setEditorCtx(ctx);
  };

  const getPath = (section: string, item: string) => {
    const basePath = section.split(".").slice(1)
    return [...basePath, item].join(".")
  }

  const onUpdateConfig = (config:any, item: string) =>{
    if(type==="Scanner" && item==="readOnly") {
      return { ...config, readOptions:"view" }
    } else {
        return { ...config }
      }
  }

  const handleSetPluginConfig = (section: string, configItem: string, value: any) => {
    const data: any = _.setWith({}, section, { [configItem]: value }, Object)
    const updatedConfig = _.merge(pluginConfig, properties, data.properties)
    const finalPluginConfig: any = onUpdateConfig(updatedConfig,configItem)
    setPluginConfig(finalPluginConfig, () => onChange(finalPluginConfig, type === "TabBar" ? "name" : "properties"))
  }

  return (
    <div className={style.body + "props-body"}>
      {type && !["TabBar"].includes(type) && (
        <Form.Item label="Id" className={"a8-form-item props"}>
          <Input
            placeholder="Id"
            className={style.borderRemove}
            value={idValue}
            disabled={!canEdit}
            onChange={(e) => {
              const value = e.target.value.replace(/\s/g, "");
              setIdValue(value, () => onChange(value, "elementId"));
            }}
          />
        </Form.Item>
      )}
      {type &&
        properties &&
        !properties.layout &&
        ![
          "CheckList",
          "DocumentCollector",
          "Section",
          "TabBar",
          "Container",
        ].includes(type) && (
          <Form.Item label="size" className={"a8-form-item props"}>
            <Select
              data-test-id="property_size"
              defaultValue={currentState && currentState.size}
              style={{ width: "100%" }}
              className={style.borderRemove}
              disabled={!canEdit}
              onChange={(e: any) => onChange(e, "size")}
            >
              <Option data-test-id="property_size_small" value="col-md-4">Small</Option>
              <Option data-test-id="property_size_medium" value="col-md-6">Medium</Option>
              <Option data-test-id="property_size_Large" value="col-md-12">Large</Option>
            </Select>
          </Form.Item>
        )}
      {type &&
        ![
          "Container",
          "Section",
          "TabBar",
          "Button",
          "ImageViewer",
          "Table",
          "Divider",
        ].includes(type) && <>{renderBindComponent()}</>}
      {type &&
        [
          "Container"
        ].includes(type) && assetEditMode && (
          <Form.Item label="label" className={"a8-form-item props"}>
            <Input
              data-test-id="property_label"
              placeholder="Label"
              className={style.borderRemove}
              value={labelValue}
              disabled={!props.canEdit}
              onChange={(e) => {
                const value = e.target.value;
                setLabelValue(value, () => onChange(
                  value,
                  type === "TabBar" ? "name" : "properties.label"
                ))
              }}
            />
          </Form.Item>
        )}
        {type && ![
            "Container",
            "Section",
            "TabBar",
            "Button",
            "ImageViewer",
            "Table",
            "Divider",
            "Scanner",
            "Uploader",
            "Otp"
          ].includes(type) && (
            <Form.Item label="Do not persist bind" className={"a8-form-item props"}>
            <Switch
              checked={persistBlock}
              disabled={!canEdit}
              onChange={async (e) => {
                setPersistBlock(e);
                onChange(e, "properties.persistBlock");
              }}
            />
          </Form.Item>
        )
      }
      {type && !["TabBar"].includes(type) && (
        <>
          <Form.Item label="Visible" className={"a8-form-item props"}>
            <Switch
              checked={isVisible}
              disabled={!canEdit}
              onChange={async (e) => {
                setIsVisible(e);
                onChange(e, "properties.visibility.checked");
              }}
            />
          </Form.Item>
          <Form.Item
            label={`${!isVisible ? "Show" : "Hide"} Element On`}
            className={"a8-form-item props"}
          >
            <Input
              placeholder="eg: $b.bindParam === 'value'"
              className={style.borderRemove}
              disabled={!canEdit}
              value={visibilityValue}
              onChange={(e) => {
                const value = e.target.value;
                setVisibilityValue(value, () => onChange(value, "properties.visibility.condition"));
                // onChange(value, "properties.visibility.condition");
              }}
            />
          </Form.Item>
        </>
      )}

      {renderPanel()}



      {currentState && currentState.type && originalConfig &&
        Object.keys(originalConfig).map((configItem, index) => {
          const field = originalConfig[configItem]

          return (
            <div key={index}>
              {field.type === String && field.label !== "Label" && field.label !== "Placeholder" && shouldShowField(field) && (
                <Form.Item
                  label={field.label}
                  className={"a8-form-item props"} >
                  <Input
                    data-test-id={`${pluginConfig[configItem]}`}
                    placeholder={field.placeholder}
                    className={style.borderRemove}
                    value={_.get(pluginConfig, getPath(field.section, configItem))}
                    disabled={!canEdit}
                    onChange={(e) => {
                      const value = e.target.value;
                      handleSetPluginConfig(field.section, configItem, value)
                    }}
                  />
                </Form.Item>
              )}
              {field.type === String && field.label === "Label" && shouldShowField(field) && (
                <Form.Item
                  label={field.label}
                  className={"a8-form-item props"}>
                  {
                    labelBlur ?
                      <div onClick={() => setLabelBlur(false)}><I18AutoCompletion dataTestId={`${pluginConfig[configItem]}`}
                        value={_.get(pluginConfig, getPath(field.section, configItem)).toString()} /></div>
                      :
                      <CustomAutoComplete
                        dataTestId={`${pluginConfig[configItem]}`}
                        disabled={!canEdit}
                        placeholder={field.placeholder}
                        value={_.get(pluginConfig, getPath(field.section, configItem))}
                        defaultValue={_.get(pluginConfig, getPath(field.section, configItem))}
                        onChange={(val) => handleSetPluginConfig(field.section, configItem, val)}
                        onSelect={(val) => handleSetPluginConfig(field.section, configItem, val)}
                        onBlur={() => setLabelBlur(true)}
                      />
                  }
                </Form.Item>
              )}

              {field.type === String && field.label === "Placeholder" && shouldShowField(field) && (
                <Form.Item
                  label={field.label}
                  className={"a8-form-item props"}>
                  {
                    placeBlur ?
                      <div onClick={() => setPlaceBlur(false)}><I18AutoCompletion dataTestId={`${pluginConfig[configItem]}`}
                        value={_.get(pluginConfig, getPath(field.section, configItem)).toString()} /></div>
                      :
                      <CustomAutoComplete
                        dataTestId={`${pluginConfig[configItem]}`}
                        disabled={!canEdit}
                        placeholder={field.placeholder}
                        value={_.get(pluginConfig, getPath(field.section, configItem))}
                        defaultValue={_.get(pluginConfig, getPath(field.section, configItem))}
                        onChange={(val) => handleSetPluginConfig(field.section, configItem, val)}
                        onSelect={(val) => handleSetPluginConfig(field.section, configItem, val)}
                        onBlur={() => setPlaceBlur(true)}
                      />
                  }
                </Form.Item>
              )}
              {field.type === "MultiSelect" && shouldShowField(field) && (
                <Form.Item label="File Type" className="a8-form-item props">
                  <Select
                    data-test-id="property_scanner_multiple_type"
                    mode="multiple"
                    style={{ width: "100%" }}
                    disabled={!props.canEdit}
                    className={style.borderRemove}
                    placeholder="Default: All Files"
                    value={selectedValue}
                    onChange={(e) => {
                      let values = [...e];
                      const isAllFilesSelected = values.includes("allFiles");

                      if (isAllFilesSelected) {
                        values = ["allFiles"]; // override values to just allFiles
                      } else {
                        // Remove "allFiles" if previously selected
                        values = values.filter((val) => val !== "allFiles");
                      }
                      setSelectedValue(values);

                      const finalConfig = {...properties, fileType: values}
                      onChange(values, "properties.fileType")
                      setPluginConfig(finalConfig, () => onChange(finalConfig, "properties"))
                    }}
                  >
                    {field.values.map((x: any) => (
                      <Option
                        data-test-id={`properties_multi_upload_${x.value}`}
                        disabled={pluginConfig.fileType === "allFiles"}
                        label={x.value}
                        key={x.value}
                      >
                        {x.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
              {json.json.type === "Otp" && field.type === Number && shouldShowField(field) && (
                <Form.Item label={field.label} className={"a8-form-item props"}>
                  <InputNumber
                    type="number"
                    style={{ width: "100%" }}
                    placeholder={field.placeholder}
                    className={style.borderRemove}
                    min={1}
                    disabled={!canEdit}
                    value={pluginConfig[configItem] || ""}
                    onChange={(value: any) => handleSetPluginConfig(field.section, configItem, value)}
                  />
                </Form.Item>
              )}
              {field.type === Array && shouldShowField(field) && (
                <Form.Item
                  label={field.label}
                  className={"a8-form-item props"}
                >
                  <Select
                    data-test-id="select_properties_panel"
                    placeholder={configItem}
                    style={{ width: "100%" }}
                    className={style.borderRemove}
                    disabled={!canEdit}
                    defaultValue={_.get(pluginConfig, getPath(field.section, configItem))}
                    onChange={(value: any) => handleSetPluginConfig(field.section, configItem, value)}
                  >
                    {field.values.map(
                      (list: any, key: number) => (
                        <Option data-test-id={`${list.label}`} key={key} value={list.value}>
                          {list.label}
                        </Option>
                      )
                    )}
                  </Select>
                </Form.Item>
              )}
              {field.type === Boolean && shouldShowField(field) && (
                <Form.Item
                  label={field.label}
                  className={"a8-form-item props"}
                >
                  <Switch
                    checked={pluginConfig[configItem]}
                    disabled={!canEdit}
                    onChange={(e: any) => handleSetPluginConfig(field.section, configItem, e)}
                  />
                </Form.Item>
              )}

              {field.type === Function && shouldShowField(field) && (
                <>
                  <div className={style.propertiesLabelContainer}>
                    {field.label}
                  </div>
                  <div
                    data-test-id="properties_panel_code_editor"
                    className={style.codeContainer}
                    onClick={() => openCodeEditorModal(configItem)}
                  >
                    {(pluginConfig[configItem] && pluginConfig[configItem].fun) ||
                      `async function main() {
                          // Start of editable area

                          // End of editable area
                      }`}
                  </div>
                </>
              )}
              {field.type === Object && (
                <Form.Item label={field.label} className={"a8-form-item props"}>
                  <ColorPicker
                    disabled={!canEdit}
                    defaultColor={
                      (pluginConfig.theme && pluginConfig.theme[configItem]) || {
                        r: 255,
                        g: 255,
                        b: 255,
                        a: 1,
                      }
                    }
                    handleSubmit={(color) => handleSetPluginConfig(field.section, configItem, color)}
                  />
                </Form.Item>
              )}
            </div>
          );
        })}

      {
        modalVisibile && <TarsLayout
          setCurrentLine={setCurrentLine}
          currentLine={currentLine}
          visibleTars={true}
          tarsModal={tarsModal}
          setTarsModal={setTarsModal}
          value={pluginConfig[editorCtx] && pluginConfig[editorCtx].fun}
          json={currentState}
          lang={"javascript"}
          readOnly={!canEdit}
          onSave={(
            value: { source: string; comSource: string },
            modalId: Boolean
          ) => {
            onChange(value.source, `properties.${editorCtx}.fun`);
            handleSetPluginConfig(`properties.${editorCtx}`, "fun", value.source)
            if (modalId) {
              setModalVisible(false);
            }
          }}
          height="450px"
          width="98%"
          customdef={functionsdef}
          type="inline"
          saveMessage={{
            enable: true,
            message: "Click handler added",
          }}
          onOk={() => {
            let modalId: number = 7238212;
            let event = new KeyboardEvent("keydown", {
              key: "s",
              code: "KeyS",
              ctrlKey: true,
              detail: modalId,
            });
            document.dispatchEvent(event);
          }}
          editorRef={editorRef} title="CODE EDITOR" modalVisibile={modalVisibile} canEdit={canEdit} setModalVisible={setModalVisible}></TarsLayout>
      }

    </div>
  );
};

export default PropertiesPanel;
